import React from "react";
import { Field } from "react-final-form";
 import { TextFieldAdapter }from "@soqs/common";;

const CompanyNameTrustName = (props) => {
  const isValid = (value) => {
    // if (value != null && value !== "") {
    return value ? undefined : "Please enter Company Name or Trust Name";
  };
  // };
  return (
    <Field
      name="trnTradingName"
      validate={isValid}
      label="Company Name or Trust Name"
      component={TextFieldAdapter}
      subscription={{ touched: true, value: true, error: true }}
      fullWidth
      inputProps={{ maxLength: 35 }}
      required
      {...props}
    />
  );
};

export default CompanyNameTrustName;
